module["exports"] = [
  "#{street_name} #{building_number}"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/sv/address/street_address.js
 ** module id = 1063
 ** module chunks = 0
 **/